/* HYLOR — minimal, progressive-enhancement only.
   Content is fully visible without JS. Honors prefers-reduced-motion. */
(function(){
  'use strict';

  /* Header: gain cream background + hairline once scrolled past 24px */
  var header = document.querySelector('[data-hylor-header]');
  if (header) {
    var onScroll = function(){
      if (window.scrollY > 24) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  /* Mobile menu: open/close with focus trap + Escape */
  var toggle = document.querySelector('[data-menu-toggle]');
  var menu   = document.querySelector('[data-mobile-menu]');
  var close  = document.querySelector('[data-menu-close]');
  if (toggle && menu) {
    var open = function(){
      menu.classList.add('is-open');
      toggle.setAttribute('aria-expanded','true');
      document.body.style.overflow = 'hidden';
      if (close) close.focus();
    };
    var shut = function(){
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded','false');
      document.body.style.overflow = '';
      toggle.focus();
    };
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    menu.addEventListener('click', function(e){
      if (e.target.tagName === 'A') shut();
    });
    document.addEventListener('keydown', function(e){
      if (!menu.classList.contains('is-open')) return;
      if (e.key === 'Escape') { shut(); return; }
      if (e.key !== 'Tab') return;
      var f = menu.querySelectorAll('a[href],button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length-1];
      if (e.shiftKey && document.activeElement === first){ last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last){ first.focus(); e.preventDefault(); }
    });
    window.addEventListener('resize', function(){
      if (window.innerWidth > 1000 && menu.classList.contains('is-open')) shut();
    });
  }

  /* Experience cards: one-time 85ms-staggered fade, gated on reduced-motion */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fades = document.querySelectorAll('.js-fade');
  if (fades.length && !reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){
          var el = en.target;
          var i = parseInt(el.getAttribute('data-fade-index')||'0',10);
          setTimeout(function(){ el.classList.add('is-in'); }, i*85);
          io.unobserve(el);
        }
      });
    }, {threshold:0.15});
    fades.forEach(function(el){ io.observe(el); });
  } else {
    fades.forEach(function(el){ el.classList.add('is-in'); });
  }
})();
